import { memo, useState } from 'react';
import { Alert, Button, Form, Input } from 'antd';
import { SendOutlined } from '@ant-design/icons';

import { verifyEmailApi } from 'apis/auth/login';

import styles from './EmailForm.module.css';
import Title from './Title';

interface EmailFormProps {
  email: string;
  setEmail: (email: string) => void;
  setIsAuthCodeSended: (isAuthCodeSended: boolean) => void;
}

function EmailForm({ email, setEmail, setIsAuthCodeSended }: EmailFormProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  const verifyEmail = () => {
    setIsLoading(true);

    verifyEmailApi(email)
      .then(() => setIsAuthCodeSended(true))
      .catch((errMsg) => {
        if (errMsg !== '') {
          setErrMsg(errMsg);
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="center-align-container full-width">
      <Title
        title="이메일로 로그인해보세요"
        subtitle={{ emphasis: '직장에서 사용하는 이메일 주소', normal: '로 로그인하는 걸 추천드려요.' }}
      />
      <Form className={styles.form} onFinish={verifyEmail}>
        <Form.Item validateStatus={errMsg ? 'error' : undefined} help={errMsg} rules={[{ type: 'email' }]}>
          <Input
            size="large"
            type="email"
            placeholder="username@domainname"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrMsg('');
            }}
            disabled={isLoading}
          />
        </Form.Item>
        <Form.Item>
          <Button loading={isLoading} size="large" block type="primary" htmlType="submit" icon={<SendOutlined />}>
            이메일로 로그인
          </Button>
        </Form.Item>
        <Alert
          className={styles.message}
          message={
            <>
              이메일로 발송되는 <b>6자리 매직 코드</b>를 통해 비밀번호 없이 로그인할 수 있어요.
            </>
          }
          showIcon
        />
      </Form>
    </div>
  );
}

export default memo(EmailForm);
